export const HELP_FAQ = [
  {
    question: 'What is Velox Network?',
    answer:
      'Velox is a relationship system for people whose work depends on introductions. It captures the people you meet, keeps their details current, and helps you remember, find and follow up. A contactless card is one way to share in the room. You can start with a digital profile.',
  },
  {
    question: 'How does the NFC business card work?',
    answer:
      'Our metal NFC cards contain a chip that can be tapped with any smartphone. When someone taps your card, it instantly opens your digital business card page with all your contact information, social links, and more.',
  },
  {
    question: "What's the benefit vs paper business cards?",
    answer:
      'Unlike paper cards, Velox cards never go out of date. You can update your information anytime, and everyone who has your card automatically gets the latest details. Plus, you can track who viewed your card and when.',
  },
  {
    question: 'What does the company dashboard do?',
    answer:
      "A company account gives administrators visibility of their team's networking activity: contacts captured, card taps and engagement over time, broken down by team and by individual. Private notes stay private to the person who wrote them.",
  },
  {
    question: 'Can I use Velox without my company?',
    answer:
      'Yes. You can order a single card at veloxco.com and use Velox independently, with your own profile, contact capture and analytics. If your employer adopts Velox later, your account carries across.',
  },
  {
    question: 'Custom cards or a standard one?',
    answer:
      'Both. A standard Velox card can be ordered at veloxco.com and arrives ready to activate. For a custom card, use Get started and tell us what you want: our design team will work the artwork up with you, or produce your own, and come back with a proof and a price. Either card gives you the same platform.',
  },
  {
    question: 'What are you still building?',
    answer:
      'Anything not yet live is labelled "in development" wherever it appears on this site. That currently covers automated AI follow-ups, role-based seats that survive a leaver, automated org charting, meeting and event outcome reporting, seeing who from your network is attending an event, and designing a card on the site.',
  },
];

export const HELP_START = [
  {
    title: 'Create your profile',
    body: 'Register and add your role, company, contact details and links. You do not need a physical card to start.',
  },
  {
    title: 'Share and capture',
    body: 'Send a link, or tap a card when you have one. The other person can send their details back without a Velox account.',
  },
  {
    title: 'Keep the context',
    body: 'Notes, place and date stay with the person. When they update their details, your copy updates too.',
  },
];
